// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE LOX MINIMUM, MIRRORED FROM backend/constants/lox.js.
//
// 🚨 IT WAS WRITTEN TWICE IN THE FRONTEND ALONE — Verification.js and
// Dashboard.js each carried `const LOX_MIN = 20` — and the server enforced no
// minimum whatsoever, so the only thing stopping a one-character letter of
// explanation from being filed as a signed PDF was a disabled button.
//
// ⚠️ THE SERVER IS THE GATE NOW AND THIS IS THE COPY THAT KEEPS THE BUTTON
// HONEST. test/loxMinimumParity.test.js asserts the two numbers are equal; a
// client that allowed less would show a borrower a submit button that fails.
// ─────────────────────────────────────────────────────────────────────────────
export const LOX_MIN_CHARS = 20;
export const loxTooShort = (text) => String(text == null ? '' : text).trim().length < LOX_MIN_CHARS;
